import { render } from "./MenuTilesList.vue?vue&type=template&id=cd17c39c&scoped=true"
import script from "./MenuTilesList.vue?vue&type=script&lang=js"
export * from "./MenuTilesList.vue?vue&type=script&lang=js"

import "./MenuTilesList.vue?vue&type=style&index=0&id=cd17c39c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd17c39c"]])

export default __exports__